import axios from "axios"

export class LocalizationService {
    static async getWidgetInfo(authToken) {
        return axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/widget-info`,
            {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            }
        )
    }
}
